// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --anvur-color: #0033A0;
}

.anvur-tags { 
  background-color: var(--anvur-color); 
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/Anvur.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd","sourcesContent":[":root {\n  --anvur-color: #0033A0;\n}\n\n.anvur-tags { \n  background-color: var(--anvur-color); \n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
